import { render, staticRenderFns } from "./imgQ.vue?vue&type=template&id=77cc91ea&scoped=true"
var script = {}
import style0 from "./imgQ.vue?vue&type=style&index=0&id=77cc91ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc91ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77cc91ea')) {
      api.createRecord('77cc91ea', component.options)
    } else {
      api.reload('77cc91ea', component.options)
    }
    module.hot.accept("./imgQ.vue?vue&type=template&id=77cc91ea&scoped=true", function () {
      api.rerender('77cc91ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgQ.vue"
export default component.exports